import React from 'react';
import DashboardPreview from '../DashboardPreview';
import { useVariantCopy } from './useVariantCopy';

// Platform demo only — the feature/benefit cards moved to FeatureCards so
// HomeVariant can place them under the pricing cards.
const PlatformAndFeatures = () => {
	const L = useVariantCopy();

	return (
		<section className="stripe-section--gradient pb-10 md:pb-16">
			<div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
				{/* Dashboard Preview Section */}
				<div className="mt-20 md:mt-32">
					<div className="text-center mb-8 md:mb-12 px-2">
						<span className="inline-block px-3 py-1 md:px-4 md:py-1.5 bg-instagram text-white text-xs md:text-sm font-semibold rounded-full mb-3 md:mb-4">{L.header.dashboardLabel}</span>
						<h2 className="text-2xl sm:text-3xl md:text-4xl font-bold stripe-text-dark mb-3 md:mb-4">{L.header.dashboardTitle}</h2>
						<p className="text-base md:text-xl stripe-text-body max-w-2xl mx-auto">
							{L.header.dashboardSub}
						</p>
					</div>

				<div className="relative max-w-5xl mx-auto px-2 sm:px-0">
					<div className="absolute inset-0 bg-purple-400 rounded-2xl blur-3xl opacity-15 -z-10 transform scale-95"></div>
					<div className="relative overflow-hidden rounded-2xl md:rounded-3xl">
						<DashboardPreview />
						<div className="absolute bottom-0 left-0 right-0 h-1/3 pointer-events-none" style={{ background: 'linear-gradient(to top, #ffffff 0%, #ffffff 10%, transparent 100%)' }}></div>
					</div>
				</div>

				</div>
			</div>
		</section>
	);
};

export default PlatformAndFeatures;
